import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { deleteQuery, getAllQueries, respondQuery, submitQuery } from "./queries";

const queriesApi = createApi({
  reducerPath: "queriesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    // get all queries
    getAllQueries: builder.query({
      providesTags: ["queries"],
      query: getAllQueries,
    }),

    // respond to query
    respondQuery: builder.mutation({
      invalidatesTags: ["queries"],
      query: respondQuery,
    }),

    // delete query
    deleteQuery: builder.mutation({
      invalidatesTags: ["queries"],
      query: deleteQuery,
    }),

    // submit query
    submitQuery: builder.mutation({
      invalidatesTags: ["queries"],
      query: submitQuery
    })
  }),
});

export const {
  useGetAllQueriesQuery,
  useRespondQueryMutation,
  useDeleteQueryMutation,
  useSubmitQueryMutation,
  reducerPath: queriesApiReducerPath,
  reducer: queriesApiReducer,
  middleware: queriesApiReducerMiddleware,
} = queriesApi;
